import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { IconButton } from '../../../common/components/buttons';
import { Icon } from '../../../common/components/icons';
import { TableRowActionExact } from '../../models/tableRowAction';
import useStyles from './Action.styles';

const Action = ({ action, rowValue }) => {
  const classes = useStyles();

  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();
      action.onClick(rowValue);
    },
    [action, rowValue]
  );

  if (action.render) return action.render();

  return (
    <IconButton onClick={handleClick} className={classes.action}>
      <Icon icon={action.icon} />
    </IconButton>
  );
};

Action.propTypes = {
  action: TableRowActionExact.isRequired,
  rowValue: PropTypes.shape().isRequired,
};

export default Action;
